import CheckingEN from './checking/locales/en.json'
import CheckingPT from './checking/locales/pt-BR.json'
import DeliveryEN from './delivery/locales/en.json'
import DeliveryPT from './delivery/locales/pt-BR.json'
import MainLayoutEN from './main-layout/locales/en.json'
import MainLayoutPT from './main-layout/locales/pt-BR.json'
import PickingEN from './picking/locales/en.json'
import PickingPT from './picking/locales/pt-BR.json'
import PickingDeliveryListPageEN from './picking-delivery-list/locales/en.json'
import PickingDeliveryListPagePT from './picking-delivery-list/locales/pt-BR.json'
import SignInPageEN from './sign-in/locales/en.json'
import SignInPagePT from './sign-in/locales/pt-BR.json'
import SignInTestPageEN from './sign-in-test/locales/en.json'
import SignInTestPagePT from './sign-in-test/locales/pt-BR.json'
import ToListPageEN from './to-list/locales/en.json'
import ToListPagePT from './to-list/locales/pt-BR.json'

export const localesModulesEN = {
  Delivery: DeliveryEN,
  SignInPage: SignInPageEN,
  SignInTestPage: SignInTestPageEN,
  PickingDeliveryListPage: PickingDeliveryListPageEN,
  MainLayout: MainLayoutEN,
  Picking: PickingEN,
  ToListPage: ToListPageEN,
  Checking: CheckingEN,
}

export const localesModulesPT = {
  Delivery: DeliveryPT,
  SignInPage: SignInPagePT,
  SignInTestPage: SignInTestPagePT,
  PickingDeliveryListPage: PickingDeliveryListPagePT,
  MainLayout: MainLayoutPT,
  Picking: PickingPT,
  ToListPage: ToListPagePT,
  Checking: CheckingPT,
}
